export default {
  countries: [],
  discount: 0,
  regions: [],
  providers: [],
}
